import type {
  PosVoidReasonInput,
  PosVoidReasonsResponse,
  PosVoidReasonsSaveResponse,
} from '@/api/types'
import { apiRequest } from '@/api/client'

export const posVoidReasonsApi = {
  get: (restaurantId: number) =>
    apiRequest<PosVoidReasonsResponse>(
      `/api/v0/admin/pos-void-reasons/${restaurantId}`,
    ),
  save: (restaurantId: number, items: Array<PosVoidReasonInput>) =>
    apiRequest<PosVoidReasonsSaveResponse>(
      `/api/v0/admin/pos-void-reasons/${restaurantId}`,
      {
        method: 'PUT',
        body: JSON.stringify({ items }),
      },
    ),
}
